import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Footer.css";
import { fetchWithCache } from "../utils/cache";

const useFooterData = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    fetchWithCache("/footer.json")
      .then(setData)
      .catch(() => {
        // Fallback if fetch fails
        fetch("/footer.json")
          .then((res) => res.json())
          .then(setData);
      });
  }, []);
  return data;
};

const Footer = () => {
  const data = useFooterData();
  const location = useLocation();
  if (!data) return null;
  const year = new Date().getFullYear();


  return (
    <footer className="footer-root-new">
      <div className="footer-main-new">
        {/* Brand Section - Centered, Big, Same as Header */}
        <div className="footer-brand-new">
          <Link to="/" className="footer-logo-link">
            <div className="footer-logo-text">IQ Leap</div>
          </Link>
          <div className="footer-tagline-new">{data.brand.tagline}</div>
        </div>

        {/* Navigation Links - Important Menu Items */}
        <div className="footer-nav-new">
          {data.quickLinks.map((link, i) => (
            <Link
              key={i}
              to={link.href}
              className="footer-nav-link"
              onClick={(e) => {
                // If already on the same path, force a hard reload to reset state and scroll
                if (location.pathname === link.href) {
                  e.preventDefault();
                  window.location.assign(link.href);
                } else {
                  // Ensure we start at top after navigation
                  try { window.scrollTo({ top: 0, left: 0, behavior: "auto" }); } catch {}
                }
              }}
            >
              {link.label}
            </Link>
          ))}
        </div>

        

        {/* Contact Info - Email, Phone, Location with Icons */}
        <div className="footer-contact-new">
          <div className="contact-item">
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24" className="contact-icon">
              <path fill="#22d3ee" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
            </svg>
            <a href={`mailto:${data.contact.email}`} className="contact-link">{data.contact.email}</a>
          </div>

          <div className="contact-item">
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24" className="contact-icon">
              <path fill="#22d3ee" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            </svg>
            <span className="contact-link">{data.contact.location}</span>
          </div>
          {Array.isArray(data.social) && data.social.map((s, idx) => (
            s.platform === "LinkedIn" ? (
              <div className="contact-item" key={`social-${idx}`}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" role="img" aria-hidden="true" className="contact-icon">
                  <path fill="#0A66C2" d="M20.447 20.452H17.21v-5.569c0-1.329-.027-3.039-1.852-3.039-1.853 0-2.136 1.447-2.136 2.943v5.665H9.001V9h3.112v1.561h.045c.433-.82 1.492-1.684 3.07-1.684 3.283 0 3.887 2.162 3.887 4.974v6.601zM5.337 7.433a1.807 1.807 0 110-3.614 1.807 1.807 0 010 3.614zM6.89 20.452H3.782V9H6.89v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.728v20.543C0 23.226.792 24 1.771 24h20.451C23.2 24 24 23.226 24 22.271V1.728C24 .774 23.2 0 22.225 0z"/>
                </svg>
                <a href={'https://www.linkedin.com/company/theiqleap/'} target="_blank" rel="noopener noreferrer" className="contact-link">LinkedIn</a>
              </div>
            ) : null
          ))}
        </div>
      </div>

      {/* Copyright Section - Separate Background */}
      <div className="footer-copyright-section">
        <div className="copyright-content">
          <p className="copyright-text">
            {data.copyright.text.replace(/\d{4}/, year)}
          </p>
          {/* <p className="designer-credit">
            Designed by{" "}
            <a 
              href="https://akshaybolusani-portfolio.vercel.app/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="designer-link"
            >
              Akshay Kumar Bolusani
            </a>
          </p> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
